module.exports = __webpack_public_path__ + "img/paninti.317c849.png";